









































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AppMediumsModule } from '@/store/Settings/AppMediumsModule';
import UpdateAppMediumRequest from '@/models/Settings/AppMediums/UpdateAppMediumRequest';
import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";
import AppMediumType from "@/models/Settings/AppMediums/AppMediumType";

@Component({ name: 'AppMediumEdit' })
export default class extends SaascadaVueDialog {

    dialog = false;
    isAppMediumEnabled = true;
    request: UpdateAppMediumRequest = new UpdateAppMediumRequest();
    AppMediumType = AppMediumType;
    whitelistAsString: string = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {

            // Intitialise the local variables in the edit form
            this.isAppMediumEnabled = this.currentAppMedium.state === AppMediumState.Enabled;

            // Initialise the fields in the request
            this.request = new UpdateAppMediumRequest();
            this.whitelistAsString = '';
            this.request.name = this.currentAppMedium.name;
            this.request.state = this.currentAppMedium.state;
            this.request.accessTokenLifetime = this.currentAppMedium.accessTokenLifetime;
            this.request.refreshTokenLifetime = this.currentAppMedium.refreshTokenLifetime;

            if (this.currentAppMedium.whitelist && this.currentAppMedium.whitelist.length !== 0) {
                for (let index = 0; index < this.currentAppMedium.whitelist.length; index++) {
                    const element = this.currentAppMedium.whitelist[index];
                    if (this.whitelistAsString === "") {
                        // The first one no comma needed
                        this.whitelistAsString = element;
                    }
                    else {
                        this.whitelistAsString = this.whitelistAsString + ",";
                        this.whitelistAsString = this.whitelistAsString + element;
                    }
                }
            }
        }
    }

    get currentAppMedium() {
        return AppMediumsModule.appMedium;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.whitelistAsString !== '' ) {
                if (this.whitelistAsString.lastIndexOf(',') === 0) {
                    this.request.whitelist.push(this.whitelistAsString);
                }
                else {
                    this.request.whitelist = this.whitelistAsString.split(',');
                }
            }

            // Set the state
            this.request.state = this.isAppMediumEnabled ? AppMediumState.Enabled : AppMediumState.Disabled;

            // Sanitisation that trims the whitespace off every item in the whitelist array
            this.request.whitelist = this.request.whitelist.map((whitelistItem) => { return whitelistItem.trim(); });

            // Check if the tokens are set as they are only valid on certain app medium types and shouldn't be sent if not required
            this.request.accessTokenLifetime = this.request.accessTokenLifetime ? Number(this.request.accessTokenLifetime) : undefined;
            this.request.refreshTokenLifetime = this.request.refreshTokenLifetime ? Number(this.request.refreshTokenLifetime) : undefined;

            await AppMediumsModule.editAppMedium(this.request);
        }
    }

}
